import { FormlyFieldConfig } from '@ngx-formly/core';
import { tap, startWith } from 'rxjs/operators';
import { fieldArrayConfig, getFieldArrayprops, variablePoolPathHook, idFieldsHook } from '../utilities/helpers';

export const integrationName: FormlyFieldConfig = {
    name: 'INTEGRATION_NAME',
    fieldGroup: [
        {
            key: 'type',
            defaultValue: 'INTEGRATION_NAME',
        },
        {
            key: 'label',
            type: 'input',
            className: 'step-builder-field',
            defaultValue: 'Integration Name',
            props: {
                type: 'text',
                label: 'Label',
                required: true,
                appearance: 'outline'
            }
        },
        {
            key: 'id',
            type: 'input',
            className: 'step-builder-field',
            defaultValue: 'integrationName',
            props: {
                type: 'text',
                label: 'Id',
                required: true,
                appearance: 'outline'
            },
            hooks: {
                onInit: (field) => {
                    return idFieldsHook(field)
                }
            }
        },
        {
            key: 'minLength',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'number',
                label: 'Min Length',
                required: true,
                appearance: 'outline'
            }
        },
        {
            key: 'maxLength',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'number',
                label: 'Max Length',
                required: true,
                appearance: 'outline'
            }
        },
        {
            key: 'helpText',
            type: 'input',
            className: 'step-builder-field',
            defaultValue: '',
            props: {
                type: 'text',
                label: 'Description',
                required: false,
                appearance: 'outline'
            }   
        },
        {
            key: 'required',
            type: 'radio',
            className: 'step-builder-field',
            defaultValue: 'true',
            props: {
                label: 'Required',
                required: false,
                options: [
                    { value: 'true', label: 'true' },
                    { value: 'false', label: 'false' }
                  ],
            }
        },
    ]
}

export const input: FormlyFieldConfig = {
    name: 'TEXT',
    fieldGroup: [
        {
            key: 'type',
            defaultValue: 'TEXT',
        },
        {
            key: 'label',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Label',
                required: true,
                appearance: 'outline'
            }
        },
        {
            key: 'id',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Id',
                required: true,
                appearance: 'outline'
            },
            hooks: {
                onInit: (field) => {
                    return idFieldsHook(field)
                }
            }
        },
        {
            key: 'minLength',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'number',
                label: 'Min Length',
                required: true,
                appearance: 'outline'
            }
        },
        {
            key: 'maxLength',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'number',
                label: 'Max Length',
                required: true,
                appearance: 'outline'
            }
        },
        {
            key: 'helpText',
            type: 'input',
            className: 'step-builder-field',
            defaultValue: '',
            props: {
                type: 'text',
                label: 'Description',
                required: false,
                appearance: 'outline'
            }   
        },
        {
            key: 'required',
            type: 'radio',
            className: 'step-builder-field',
            defaultValue: 'false',
            props: {
                label: 'Required',
                required: false,
                options: [
                    { value: 'true', label: 'true' },
                    { value: 'false', label: 'false' }
                  ],
            }
        },
    ]
}

export const textarea: FormlyFieldConfig = {
    name: 'TEXTAREA',
    fieldGroup: [
        {
            key: 'type',
            defaultValue: 'TEXTAREA',
        },
        {
            key: 'label',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Label',
                required: true,
                appearance: 'outline'
            }
        },
        {
            key: 'id',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Id',
                required: true,
                appearance: 'outline'
            },
            hooks: {
                onInit: (field) => {
                    return idFieldsHook(field)
                }
            }
        },
        {
            key: 'minLength',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'number',
                label: 'Min Length',
                required: true,
                appearance: 'outline'
            }
        },
        {
            key: 'maxLength',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'number',
                label: 'Max Length',
                required: true,
                appearance: 'outline'
            }
        },
        {
            key: 'helpText',
            type: 'input',
            className: 'step-builder-field',
            defaultValue: '',
            props: {
                type: 'text',
                label: 'Description',
                required: false,
                appearance: 'outline'
            }   
        },
        {
            key: 'required',
            type: 'radio',
            className: 'step-builder-field',
            defaultValue: 'false',
            props: {
                label: 'Required',
                required: false,
                options: [
                    { value: 'true', label: 'true' },
                    { value: 'false', label: 'false' }
                  ],
            }
        },
    ]
}

export const number: FormlyFieldConfig = {
    name: 'NUMBER',
    fieldGroup: [
        {
            key: 'type',
            defaultValue: 'NUMBER',
        },
        {
            key: 'label',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Label',
                required: true,
                appearance: 'outline'
            }
        },
        {
            key: 'id',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Id',
                required: true,
                appearance: 'outline'
            },
            hooks: {
                onInit: (field) => {
                    return idFieldsHook(field)
                }
            }
        },
        {
            key: 'min',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'number',
                label: 'Min Value',
                required: true,
                appearance: 'outline'
            }
        },
        {
            key: 'max',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'number',
                label: 'Max Value',
                required: true,
                appearance: 'outline'
            }
        },
        {
            key: 'helpText',
            type: 'input',
            className: 'step-builder-field',
            defaultValue: '',
            props: {
                type: 'text',
                label: 'Description',
                required: false,
                appearance: 'outline'
            }   
        },
        {
            key: 'required',
            type: 'radio',
            className: 'step-builder-field',
            defaultValue: 'false',
            props: {
                label: 'Required',
                required: false,
                options: [
                    { value: 'true', label: 'true' },
                    { value: 'false', label: 'false' }
                  ],
            }
        },
    ]
}


export const dropdownList: FormlyFieldConfig = {
    name: 'DROPDOWN_LIST',
    fieldGroup: [
        {
            key: 'type',
            defaultValue: 'DROPDOWN_LIST',
        },
        {
            key: 'label',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Label',
                required: true,
                appearance: 'outline'
            }
        },
        {
            key: 'id',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Id',
                required: true,
                appearance: 'outline'
            },
            hooks: {
                onInit: (field) => {
                    return idFieldsHook(field)
                }
            }
        },
        {
            key: 'options',
            type: 'keyValue',
            className: 'step-builder-field',
            props: {
                ...getFieldArrayprops(),
                label: 'Options',
            },
            "fieldArray": fieldArrayConfig(undefined, undefined, undefined,'label'),
        },
        {
            key: 'helpText',
            type: 'input',
            className: 'step-builder-field',
            defaultValue: '',
            props: {
                type: 'text',
                label: 'Description',
                required: false,
                appearance: 'outline'
            }   
        },
        {
            key: 'required',
            type: 'radio',
            className: 'step-builder-field',
            defaultValue: 'false',
            props: {
                label: 'Required',
                required: false,
                options: [
                    { value: 'true', label: 'true' },
                    { value: 'false', label: 'false' }
                  ],
            }
        },
        {
            key: 'labelsJsonPath',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Labels Json Path',
                required: true,
                readonly: true,
                disabled: true,
                appearance: 'outline'
            },
            hooks: {
                onInit: (field) => {
                    return variablePoolPathHook(field, 'labels')
                }
            }
        },
        {
            key: 'valuesJsonPath',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Values Json Path',
                required: true,
                readonly: true,
                disabled: true,
                appearance: 'outline'
            },
            hooks: {
                onInit: (field) => {
                    return variablePoolPathHook(field, 'values')
                }
            }
        }

    ]        
}

export const checkbox: FormlyFieldConfig = {
    name: 'CHECKBOX',
    fieldGroup: [
        {
            key: 'type',
            defaultValue: 'CHECKBOX',
        },
        {
            key: 'label',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Label',
                required: true,
                appearance: 'outline'
            }
        },
        {
            key: 'id',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Id',
                required: true,
                appearance: 'outline'
            },
            hooks: {
                onInit: (field) => {
                    return idFieldsHook(field)
                }
            }
        },
        {
            key: 'helpText',
            type: 'input',
            className: 'step-builder-field',
            defaultValue: '',
            props: {
                type: 'text',
                label: 'Description',
                required: false,
                appearance: 'outline'
            }
        },
        {
            key: 'options',
            type: 'keyValue',
            className: 'step-builder-field',
            props: {
                ...getFieldArrayprops(),
                label: 'Options',
            },
            "fieldArray": fieldArrayConfig(undefined, undefined, undefined,'label'),
        }, 
        {
            key: 'required',
            type: 'radio',
            className: 'step-builder-field',
            defaultValue: 'false',
            props: {
                label: 'Required',
                required: false,
                options: [
                    { value: 'true', label: 'true' },
                    { value: 'false', label: 'false' }
                  ],
            }
        },
        {
            key: 'labelsJsonPath',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Labels Json Path',
                required: true,
                readonly: true,
                disabled: true,
                appearance: 'outline'
            },
            hooks: {
                onInit: (field) => {
                    return variablePoolPathHook(field, 'labels')
                }
            }
        },
        {
            key: 'valuesJsonPath',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Values Json Path',
                required: true,
                readonly: true,
                disabled: true,
                appearance: 'outline'
            },
            hooks: {
                onInit: (field) => {
                    return variablePoolPathHook(field, 'values')
                }
            }
        }
    ]
}

export const radio: FormlyFieldConfig = {
    name: 'RADIO_BUTTON',
    fieldGroup: [
        {
            key: 'type',
            defaultValue: 'RADIO_BUTTON',
        },
        {
            key: 'label',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Label',
                required: true,
                appearance: 'outline'
            }
        },
        {
            key: 'id',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Id',
                required: true,
                appearance: 'outline'
            },
            hooks: {
                onInit: (field) => {
                    return idFieldsHook(field)
                }
            }
        },
        {
            key: 'options',
            type: 'keyValue',
            className: 'step-builder-field',
            props: {
                ...getFieldArrayprops(),
                label: 'Options',
            },
            "fieldArray": fieldArrayConfig(undefined, undefined, undefined,'label'),
        },
        {
            key: 'helpText',
            type: 'input',
            className: 'step-builder-field',
            defaultValue: '',
            props: {
                type: 'text',
                label: 'Description',
                required: false,
                appearance: 'outline'
            }   
        },
        {
            key: 'required',
            type: 'radio',
            className: 'step-builder-field',
            defaultValue: 'false',
            props: {
                label: 'Required',
                required: false,
                options: [
                    { value: 'true', label: 'true' },
                    { value: 'false', label: 'false' }
                  ],
            }
        },
        {
            key: 'labelsJsonPath',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Labels Json Path',
                required: true,
                readonly: true,
                disabled: true,
                appearance: 'outline'
            },
            hooks: {
                onInit: (field) => {
                    return variablePoolPathHook(field, 'labels')
                }
            }
        },
        {
            key: 'valuesJsonPath',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Values Json Path',
                required: true,
                readonly: true,
                disabled: true,
                appearance: 'outline'
            },
            hooks: {
                onInit: (field) => {
                    return variablePoolPathHook(field, 'values')
                }
            }
        }
    ]
}


export const tables: FormlyFieldConfig = {
    name: 'TABLE_SELECT',
    fieldGroup: [
        {
            key: 'type',
            defaultValue: 'TABLE_SELECT',
        },
        {
            key: 'label',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Label',
                required: true,
                appearance: 'outline'
            }
        },
        {
            key: 'id',
            type: 'input',
            className: 'step-builder-field',
            defaultValue: 'table_select',
            props: {
                type: 'text',
                label: 'Id',
                required: true,
                appearance: 'outline'
            },
            hooks: {
                onInit: (field) => {
                   // return idFieldsHook(field)
                }
            }
        },
        {
            key: 'helpText',
            type: 'input',
            className: 'step-builder-field',
            defaultValue: '',
            props: {
                type: 'text',
                label: 'Description',
                required: false,
                appearance: 'outline'
            }   
        },
        {
            key: 'required',
            type: 'radio',
            className: 'step-builder-field',
            defaultValue: 'false',
            props: {
                label: 'Required',
                required: false,
                options: [
                    { value: 'true', label: 'true' },
                    { value: 'false', label: 'false' }
                  ],
            }
        },
        {
            key: 'tablesJsonPath',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Tables Json Path',
                required: true,
                readonly: false,
                disabled: false,
                appearance: 'outline'
            },
            hooks: {
                onInit: (field) => {
                    return variablePoolPathHook(field)
                }
            }
        },
        // {
        //     key: 'supportedLoadingModes',
        //     type: 'ng-select',
        //     className: 'step-builder-field',
        //     defaultValue: ['Append', 'Upsert', 'Inherit', 'Truncate and Re-load'],
        //     props: {
        //         label: 'Supported Loading Modes',
        //         placeholder: 'Type and hit enter',
        //         options: [ 
        //             { label: 'Append', value: 'Append' },
        //             { label: 'Upsert', value: 'Upsert' },
        //             { label: 'Inherit', value: 'Inherit' },
        //             { label: 'Truncate and Re-load', value: 'Truncate and Re-load' },
        //         ]
        //     }
        // }, 
        // {
        //     key: 'supportedLoadingModesValues',
        //     type: 'ng-select',
        //     className: 'step-builder-field',
        //     defaultValue: ['INSERT', 'UPSERT', 'INHERIT', 'WRITE_TRUNCATE'],
        //     props: {
        //         label: 'Supported Loading Modes Values',
        //         placeholder: 'Type and hit enter',
        //         options: [
        //             { label: 'Insert', value: 'INSERT' },
        //             { label: 'Upsert', value: 'UPSERT' },
        //             { label: 'Inherit', value: 'INHERIT' },
        //             { label: 'Truncate and Re-load', value: 'WRITE_TRUNCATE' },
        //         ]
        //     }
        // },
        // {
        //     key: 'supportedUnnesting',
        //     type: 'ng-select',
        //     className: 'step-builder-field',
        //     defaultValue: ['Inherit from Warehouse Settings', 'Do not flatten', 'Upto one level', 'Upto two levels'],
        //     props: {
        //         label: 'Supported Unnesting',
        //         placeholder: 'Type and hit enter',
        //         options: [
        //             { label: 'Inherit from Warehouse Settings', value: 'Inherit from Warehouse Settings' },
        //             { label: 'Do not flatten', value: 'Do not flatten' },
        //             { label: 'Upto one level', value: 'Upto one level' },
        //             { label: 'Upto two levels', value: 'Upto two levels' },
        //         ]
        //     }
        // },
        // {
        //     key: 'supportedUnnestingValues',
        //     type: 'ng-select',
        //     className: 'step-builder-field',
        //     defaultValue: ['null', '0', '1', '2'],
        //     props: {
        //         label: 'Supported Unnesting Values',
        //         placeholder: 'Type and hit enter',
        //         options: [
        //             { label: 'null', value: 'null'},
        //             { label: '0', value: '0'},
        //             { label: '1', value: '1'},
        //             { label: '2', value: '2'},
        //         ]
        //     }
        // }
    ]
}

export const columns: FormlyFieldConfig = {
    name: 'COLUMN_SELECT',
    fieldGroup: [
        {
            key: 'type',
            defaultValue: 'COLUMN_SELECT',
        },
        {
            key: 'label',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Label',
                required: true,
                appearance: 'outline'
            }
        },
        {
            key: 'id',
            type: 'input',
            className: 'step-builder-field',
            defaultValue: 'column_select',
            props: {
                disabled: true,
                type: 'text',
                label: 'Id',
                required: true,
                appearance: 'outline'
            },
            hooks: {
                onInit: (field) => {
                    return idFieldsHook(field)
                }
            }
        },
        {
            key: 'helpText',
            type: 'input',
            className: 'step-builder-field',
            defaultValue: '',
            props: {
                type: 'text',
                label: 'Description',
                required: false,
                appearance: 'outline'
            }   
        },
        {
            key: 'required',
            type: 'radio',
            className: 'step-builder-field',
            defaultValue: 'false',
            props: {
                label: 'Required',
                required: false,
                options: [
                    { value: 'true', label: 'true' },
                    { value: 'false', label: 'false' }
                  ],
            }
        },
        {
            key: 'columnsJsonPath',
            type: 'input',
            className: 'step-builder-field',
            defaultValue: 'columns',
            props: {
                type: 'text',
                label: 'Columns Json path',
                required: true,
                readonly: true,
                disabled: true,
                appearance: 'outline'
            }
        },
        // {
        //     key: 'supportedUnnesting',
        //     type: 'ng-select',
        //     className: 'step-builder-field',
        //     defaultValue: ['Inherit from Warehouse Settings', 'Do not flatten', 'Upto one level', 'Upto two levels'],
        //     props: {
        //         label: 'Supported Unnesting',
        //         placeholder: 'Type and hit enter',
        //         options: [
        //             { label: 'Inherit from Warehouse Settings', value: 'Inherit from Warehouse Settings' },
        //             { label: 'Do not flatten', value: 'Do not flatten' },
        //             { label: 'Upto one level', value: 'Upto one level' },
        //             { label: 'Upto two levels', value: 'Upto two levels' },
        //         ]
        //     }
        // },
        // {
        //     key: 'supportedUnnestingValues',
        //     type: 'ng-select',
        //     className: 'step-builder-field',
        //     defaultValue: ['null', '0', '1', '2'],
        //     props: {
        //         label: 'Supported Unnesting Values',
        //         placeholder: 'Type and hit enter',
        //         options: [
        //             { label: 'null', value: 'null'},
        //             { label: '0', value: '0'},
        //             { label: '1', value: '1'},
        //             { label: '2', value: '2'},
        //         ]
        //     }
        // }
    ]
}

export const history_picker: FormlyFieldConfig = {
    name: 'HISTORY_PICKER',
    fieldGroup: [
        {
            key: 'type',
            defaultValue: 'HISTORY_PICKER',
        },
        {
            key: 'label',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Label',
                required: true,
                appearance: 'outline'
            }
        },
        {
            key: 'id',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Id',
                required: true,
                appearance: 'outline'
            },
            hooks: {
                onInit: (field) => {
                    return idFieldsHook(field)
                }
            }
        },
        {
            key: 'helpText',
            type: 'input',
            className: 'step-builder-field',
            defaultValue: '',
            props: {
                type: 'text',
                label: 'Description',
                required: false,
                appearance: 'outline'
            }   
        },
        {
            key: 'required',
            type: 'radio',
            className: 'step-builder-field',
            defaultValue: 'false',
            props: {
                label: 'Required',
                required: false,
                options: [
                    { value: 'true', label: 'true' },
                    { value: 'false', label: 'false' }
                  ],
            }
        },
        {
            key: 'historyTransformationStrategies',
            // {
            //     "type": "DATE",
            //     "id": "date_hist_strategy",
            //     "datePattern": "MM-dd-yyyy"
            //   },
            //   {
            //     "type": "WEEK",
            //     "id": "string",
            //     "zoneId": "String"
            //   },
            //   {
            //     "type": "TIMESTAMP",
            //     "id": "string",
            //     "timeStampPattern": "string",
            //     "zoneId": "string"
            //   },
            //   {
            //     "type": "DATETIME",
            //     "id": "string",
            //     "datetimePattern": "string"
            //   }
            type: 'repeat',
            className: 'step-builder-field',
            defaultValue: [],
            props: {
                addText: 'Add Strategy',
                label: 'History Transformation Strategies',
            },
            fieldArray: {
                props: {
                    btnText: 'Add Strategy',
                },
                fieldGroup: [
                    {
                        key: 'type',
                        type: 'select',
                        className: 'step-builder-field',
                        defaultValue: 'DATE',
                        props: {
                            label: 'Type',
                            required: true,
                            appearance: 'outline',
                            options: [
                                { label: 'DATE', value: 'DATE' },
                                { label: 'WEEK', value: 'WEEK' },
                                { label: 'TIMESTAMP', value: 'TIMESTAMP' },
                                { label: 'DATETIME', value: 'DATETIME' },
                            ]
                        }
                    },
                    {
                        key: 'id',
                        type: 'input',
                        className: 'step-builder-field',
                        props: {
                            type: 'text',
                            label: 'Id',
                            required: true,
                            appearance: 'outline'
                        }
                    },
                    {
                        key: 'datePattern',
                        type: 'input',
                        className: 'step-builder-field',
                        props: {
                            type: 'text',
                            label: 'Date Pattern',
                            required: false,
                            appearance: 'outline'
                        },
                        expressions: {
                            hide: (field: any) => {
                                return field.parent.model.type !== 'DATE';
                            }
                        }
                    },
                    {
                        key: 'timeStampPattern',
                        type: 'input',
                        className: 'step-builder-field',
                        props: {
                            type: 'text',
                            label: 'Timestamp Pattern',
                            required: false,
                            appearance: 'outline'
                        },
                        expressions: {
                            hide: (field: any) => {
                                return field.parent.model.type !== 'TIMESTAMP';
                            }
                        }
                    },
                    {
                        key: 'zoneId',
                        type: 'input',
                        className: 'step-builder-field',
                        props: {
                            type: 'text',
                            label: 'Zone Id',
                            required: false,
                            appearance: 'outline'
                        },
                        expressions: {
                            hide: (field: any) => {
                                return field.parent.model.type !== 'WEEK' && field.parent.model.type !== 'TIMESTAMP';
                            }
                        }
                    },
                    {
                        key: 'datetimePattern',
                        type: 'input',
                        className: 'step-builder-field',
                        props: {
                            type: 'text',
                            label: 'Datetime Pattern',
                            required: false,
                            appearance: 'outline'
                        },
                        expressions: {
                            hide: (field: any) => {
                                return field.parent.model.type !== 'DATETIME';
                            }
                        }
                    },
                ]
            }
        }
    ]        
}

export const fixed_values_slider: FormlyFieldConfig = {
    name: 'FIXED_VALUES_SLIDER',
    fieldGroup: [
        {
            key: 'type',
            defaultValue: 'FIXED_VALUES_SLIDER',
        },
        {
            key: 'label',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Label',
                required: true,
                appearance: 'outline'
            }
        },
        {
            key: 'id',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Id',
                required: true,
                appearance: 'outline'
            },
            hooks: {
                onInit: (field) => {
                    return idFieldsHook(field)
                }
            }
        },
        {
            key: 'helpText',
            type: 'input',
            className: 'step-builder-field',
            defaultValue: '',
            props: {
                type: 'text',
                label: 'Description',
                required: false,
                appearance: 'outline'
            }   
        },
        {
            key: 'options',
            type: 'keyValue',
            className: 'step-builder-field',
            defaultValue: [
                {
                    key: '1h',
                    value: '1'
                },
                {
                    key: '2h',
                    value: '2'
                },
                {
                    key: '3h',
                    value: '3'
                },
                {
                    key: '6h',
                    value: '6'
                },
                {
                    key: '8h',
                    value: '8' 
                },
                {  
                    key: '12h',
                    value: '12'
                },
                {
                    key: '24h',
                    value: '24'
                }
            ],
            props: {
                ...getFieldArrayprops(),
                label: 'Options',
                appearance: 'outline'
            },
            "fieldArray": fieldArrayConfig(undefined, undefined, undefined,'label'),
        }, 
        {
            key: 'required',
            type: 'radio',
            className: 'step-builder-field',
            defaultValue: 'false',
            props: {
                label: 'Required',
                required: false,
                options: [
                    { value: 'true', label: 'true' },
                    { value: 'false', label: 'false' }
                  ],
            }
        },
        {
            key: 'labelsJsonPath',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Labels Json Path',
                required: true,
                readonly: true,
                disabled: true,
                appearance: 'outline'
            },
            hooks: {
                onInit: (field) => {
                    return variablePoolPathHook(field, 'labels')
                }
            }
        },
        {
            key: 'valuesJsonPath',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Values Json Path',
                required: true,
                readonly: true,
                disabled: true,
                appearance: 'outline'
            },
            hooks: {
                onInit: (field) => {
                    return variablePoolPathHook(field, 'values')
                }
            }
        }
    ]        
}

export const accordionGroup: FormlyFieldConfig = {
    name: 'ACCORDION_GROUP',
    fieldGroup: [
        {
            key: 'type',
            defaultValue: 'ACCORDION_GROUP',
        },
        {
            key: 'label',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Label',
                required: true,
                appearance: 'outline'
            },
        },
        {
            key: 'id',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Id',
                required: true,
                appearance: 'outline'
            },
            hooks: {
                onInit: (field) => {
                    return idFieldsHook(field)
                }
            }
        },
        {
            key: 'helpText',
            type: 'input',
            className: 'step-builder-field',
            defaultValue: '',
            props: {
                type: 'text',
                label: 'Description',
                required: false,
                appearance: 'outline'
            }
        },
        {
            key: 'childInputElements',
            type: 'section-input-type',
            className: 'step-builder-field p-0',
            "defaultValue": [],
            props: {
                addText: 'Add child fields',
                label: 'Child Input Elements',
                deleteButtonLabel: 'Delete child field',
            },
            fieldArray: {
                fieldGroup: [
                    {
                        ...radio,
                        name: radio.name,
                        className: 'step-builder-field',
                        expressions: {
                            hide: (field: FormlyFieldConfig) => {
                                return field.model.type !== "RADIO_BUTTON"
                           }
                        },
                        "props": {
                            "label": "Radio",
                            studioInputName: 'Radio',
                            studioIcon: 'radio_button_checked',
                        },
                    }, 
                    {
                        ...checkbox,
                        name: checkbox.name,
                        className: 'step-builder-field',
                        expressions: {
                            hide: (field: FormlyFieldConfig) => {
                                return field.model.type !== "CHECKBOX"
                            }
                        },
                        "props": {
                            "label": "Checkbox",
                            studioInputName: 'Checkbox',
                            studioIcon: 'check_box',
                        }
                    }
                ]
            }
        }
    ]
}

export const entitySelect: FormlyFieldConfig = {
    name: 'ENTITY_SELECT',
    fieldGroup: [
        {
            key: 'type',
            defaultValue: 'ENTITY_SELECT',
        },
        {
            key: 'label',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Label',
                required: true,
                appearance: 'outline'
            }
        },
        {
            key: 'id',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Id',
                required: true,
                appearance: 'outline'
            },
            hooks: {
                onInit: (field) => {
                    return idFieldsHook(field)
                }
            }
        },
        {
            key: 'helpText',
            type: 'input',
            className: 'step-builder-field',
            defaultValue: '',
            props: {
                type: 'text',
                label: 'Description',
                required: false,
                appearance: 'outline'
            }   
        },
        {
            key: 'entitySourceTemplate',
            type: 'textarea',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Entity Source Template',
                required: false,
                appearance: 'outline'
            }   
        },
        {
            key: 'fieldOrder',
            type: 'ng-select',
            className: 'step-builder-field form-params-field',
            props: {
                type: 'text',
                placeholder: "type text and hit enter",
                label: 'Field Order',
                required: false,
            }   
        },
        {
            key: 'required',
            type: 'radio',
            className: 'step-builder-field',
            defaultValue: 'false',
            props: {
                label: 'Required',
                required: false,
                options: [
                    { value: 'true', label: 'true' },
                    { value: 'false', label: 'false' }
                  ],
            }
        },
    ]
}

export const oauth: FormlyFieldConfig = {
    name: 'OAUTH',
    fieldGroup: [
        {
            key: 'type',
            defaultValue: 'OAUTH',
        },
        {
            key: 'id',
            type: 'input',
            defaultValue: 'oauth',
            className: 'step-builder-field',
            props: {
                type: 'text',
                label: 'Id',
                required: true,
                appearance: 'outline'
            },
        },
        {
            key: 'authorizationEndpoint',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'textarea',
                label: 'Authorization Endpoint',
                required: false,
                appearance: 'outline'
            }   
        },
        {
            key: 'authorizationQueryParams',
            type: 'keyValue',
            className: "step-builder-field form-params-field",
            props: {
                ...getFieldArrayprops(),
                label: 'Authorization Query Params',
                paramsModificatonRequired: true,
            },
            "fieldArray": fieldArrayConfig(undefined, undefined, undefined,'key'),
        },
        {
            key: 'authorizationHeaderParams',
            type: "keyValue",
            className: "step-builder-field form-params-field",
            "props": {
                label: 'Authorization Header Params',
                ...getFieldArrayprops(),
                paramsModificatonRequired: true,
            },
            "fieldArray": fieldArrayConfig(undefined, undefined, undefined,'key'),
        },
        {
            key: 'authorizationRequestBody',
            type: "json-editor",
            className: "step-builder-field form-params-field",
            defaultValue: {},
            props: {
                "label": "Authorization Request Body",
                "autosize": true,
                "autosizeMinRows": 4,
                "mode": "text",
                "modes": ["text"],
                "expandAll": false,
                "readonly": false
            },
            validation: [{
                "required": false
            }],
        },
        {
            key: 'authorizationRequestBodyType',
            type: "select",
            className: 'step-builder-field',
            defaultValue: 'NONE',
            props: {
                type: "select",
                label: 'Authorization Request Body Type',
                required: false,
                appearance: 'outline',
                "options": [
                    { value: 'NONE', label: 'NONE' },
                    { value: 'FORM_DATA', label: 'FORM_DATA' },
                    { value: 'X_WWW_FORM_URLENCODED', label: 'X_WWW_FORM_URLENCODED' },
                    { value: 'RAW', label: 'RAW' },
                    { value: 'BINARY', label: 'BINARY' },
                    { value: 'GRAPHQL', label: 'GRAPHQL' },
                  ]
            }   
        },
        {
            key: 'authorizationRequestMethod',
            type: 'select',
            className: 'step-builder-field',
            props: {
                type: 'select',
                label: 'Authorization Request Method',
                required: false,
                appearance: 'outline',
                options: [
                    { value: 'GET', label: 'GET' },
                    { value: 'POST', label: 'POST' },
                    { value: 'PUT', label: 'PUT' },
                    { value: 'PATCH', label: 'PATCH' },
                    { value: 'DELETE', label: 'DELETE' }
                ]
            }   
        },
        {
            key: 'shouldCallTokenEndpoint',
            type: 'select',
            className: 'step-builder-field form-params-field',
            props: {
                type: 'select',
                placeholder: "select",
                label: 'Should Call Token Endpoint',
                required: false,
                options: [{value: 'true', label: 'true'}, {value: 'false', label: 'false'}]
            }   
        },
        {
            key: 'tokenEndpoint',
            type: 'input',
            className: 'step-builder-field',
            props: {
                type: 'textarea',
                label: 'Token Endpoint',
                required: false,
                appearance: 'outline'
            }   
        },
        {
            key: 'tokenQueryParams',
            type: "keyValue",
            className: "step-builder-field form-params-field",
            props: {
                label: 'Token Query Params',
                ...getFieldArrayprops(),
                paramsModificatonRequired: true,
                ...getFieldArrayprops()
            },
            fieldArray: fieldArrayConfig(undefined, undefined, undefined,'key')
        },
        {
            key: 'tokenHeaderParams',
            type: "keyValue",
            className: "step-builder-field form-params-field",
            props: {
                label: 'Token Header Params',
                ...getFieldArrayprops(),
                paramsModificatonRequired: true,
                ...getFieldArrayprops()
            },
            fieldArray: fieldArrayConfig(undefined, undefined, undefined,'key')
        },
        {
            key: 'tokenRequestBody',
            type: "json-editor",
            className: "step-builder-field form-params-field",
            defaultValue: {},
            props: {
                "label": "Token Request Body",
                "autosize": true,
                "autosizeMinRows": 4,
                "mode": "text",
                "modes": ["text"],
                "expandAll": false,
                "readonly": false
            },
            validation: [{
                "required": false
            }],
        },
        {
            key: 'tokenRequestBodyType',
            type: "select",
            className: 'step-builder-field',
            defaultValue: 'NONE',
            props: {
                type: "select",
                label: 'Token Request Body Type',
                required: false,
                appearance: 'outline',
                "options": [
                    { value: 'NONE', label: 'NONE' },
                    { value: 'FORM_DATA', label: 'FORM_DATA' },
                    { value: 'X_WWW_FORM_URLENCODED', label: 'X_WWW_FORM_URLENCODED' },
                    { value: 'RAW', label: 'RAW' },
                    { value: 'BINARY', label: 'BINARY' },
                    { value: 'GRAPHQL', label: 'GRAPHQL' },
                  ]
            }   
        },
        {
            key: 'tokenRequestMethod',
            type: 'select',
            className: 'step-builder-field',
            props: {
                type: 'select',
                label: 'Token Request Method',
                required: false,
                appearance: 'outline',
                options: [
                    { value: 'GET', label: 'GET' },
                    { value: 'POST', label: 'POST' },
                    { value: 'PUT', label: 'PUT' },
                    { value: 'PATCH', label: 'PATCH' },
                    { value: 'DELETE', label: 'DELETE' }
                ]
            }   
        },
    ]
}

export const FieldPropertyInputs = {
    INTEGRATION_NAME: integrationName,
    TEXT: input,
    TEXTAREA: textarea,
    NUMBER: number,
    DROPDOWN_LIST: dropdownList,
    CHECKBOX: checkbox,
    RADIO_BUTTON: radio,
    TABLE_SELECT: tables,
    COLUMN_SELECT: columns,
    HISTORY_PICKER: history_picker,
    FIXED_VALUES_SLIDER: fixed_values_slider,
    ACCORDION_GROUP: accordionGroup,
    ENTITY_SELECT: entitySelect,
    OAUTH: oauth,
}

export const firstStepInputElements = [
    {
      type: "INTEGRATION_NAME",
      label: "Integration Name",
      id: "integration_name",
      required: 'true',
      maxLength: 50,
      minLength: 3,
      helpText:
        "Enter the integration name. Daton will use this name to create tables in the warehouse. Once selected, this name cannot be changed.",
    },
    {
      type: "TEXT",
      required: 'false',
      helpText:
        "Please enter a description to identify the integration. You can change the description at any time.",
      label: "Description",
      id: "description",
      maxLength: 1000,
    },
    {
      type: "FIXED_VALUES_SLIDER",
      required: 'true',
      helpText:
        "Your selection will be used to schedule replication jobs at the intervals selected. Frequent replication will have an impact on billing and you can learn more by *****clicking here|https://knowledge-saras-analytics.helpjuice.com/subscription-plans-and-billing/usage-and-billing-faqs *****.",
      label: "Replication Frequency",
      id: "replication_frequency",
      labelsJsonPath: "$.replication_frequency_labels",
      valuesJsonPath: "$.replication_frequency_values",
      options: [
        {
          key: "1h",
          value: "1",
        },
        {
          key: "2h",
          value: "2",
        },
        {
          key: "3h",
          value: "3",
        },
        {
          key: "6h",
          value: "6",
        },
        {
          key: "8h",
          value: "8",
        },
        {
          key: "12h",
          value: "12",
        },
        {
          key: "24h",
          value: "24",
        },
      ],
    },
    {
      type: "HISTORY_PICKER",
      required: 'true',
      historyTransformationStrategies: [],
      helpText:
        "Select the number of years of historical data you'd like Daton to pull into your data warehouse.",
      label: "Replication Start Date",
      id: "start_date",
    },
    {
      type: "ACCORDION_GROUP",
      label: "Advanced Configuration Options",
      id: "advanced_configuration_options",
      helpText:
        "The options below allow you to control the loading behavior of Daton to fit your requirements. *****Click here|https://help.sarasanalytics.com/data/inserts-updates-and-upserts#loading-mode-overview-0***** to learn about each option and how they work.",
      childInputElements: [
        {
          type: "RADIO_BUTTON",
          required: 'true',
          helpText:
            "By default, Daton appends rows to the destination tables instead of overwriting them. Read about these options and how to effectively use them by *****Click here|https://help.sarasanalytics.com/data/inserts-updates-and-upserts#loading-mode-overview-0*****.",
          id: "loading_mode",
          labelsJsonPath: "$.loading_mode_labels",
          valuesJsonPath: "$.loading_mode_values",
          label: "Loading Mode",
          options: [
            {
              key: "Append",
              value: "INSERT",
            },
            {
              key: "Upsert",
              value: "UPSERT",
            },
          ],
        },
        {
          type: "RADIO_BUTTON",
          required: 'true',
          helpText:
            "By default, Daton will load source data in nested objects in to a single column in the destination. *****Click here|https://help.sarasanalytics.com/data/inserts-updates-and-upserts#unnesting-modes-3***** to learn more about how this option works, what impact you will see in the data warehouse, and how you can query these tables.",
          id: "loading_nested_objects",
          labelsJsonPath: "$.loading_nested_objects_labels",
          valuesJsonPath: "$.loading_nested_objects_values",
          label: "Loading Nested Objects",
          options: [
            {
              key: "Inherit from Warehouse Settings",
              value: "null",
            },
            {
              key: "Do not unnest",
              value: "0",
            },
            {
              key: "Upto one level",
              value: "1",
            },
            {
              key: "Upto two levels",
              value: "2",
            },
          ],
        },
      ],
    },
];

export const columnsInputElements = [
    {
        "type": "COLUMN_SELECT",
        "id": "column_select",
        "required": 'true',
        "columnsJsonPath": "$.column_select",
        "label": "Columns",
        "helpText": ""
    }
]

export const tablesInputElements = [
    {
        "type": "TABLE_SELECT",
        "id": "table_select",
        "required": 'true',
        "tablesJsonPath": "$.table_select",
        "label": "Tables",
        "helpText": ""
    }
]

export const oauthInputElements = [
    {
        "type": "OAUTH",
        "id": "oauth",
        "authorizationRequestBody": {},
        "authorizationRequestBodyType": "NONE",
        "tokenRequestBody": {},
        "tokenRequestBodyType": "NONE",
        "shouldCallTokenEndpoint": "",
        "tokenRequestMethod": "",
        "tokenEndpoint": "",
        "authorizationRequestMethod": "",
        "authorizationEndpoint": "",
        "authorizationQueryParams": {},
        "authorizationHeaderParams": {},
        "tokenQueryParams": {},
        "tokenHeaderParams": {}
    }
]

export const stepAutoAddedFieldsMap = {
    'FIRST_STEP_NODE' : firstStepInputElements,
    'TABLE_SELECT_STEP_NODE' : tablesInputElements,
    'COLUMN_SELECT_STEP_NODE' : columnsInputElements,
    'OAUTH_STEP_NODE': oauthInputElements,
}
